import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatosGeneralesService } from './datos-generales.service';
import { ClienteEmpresaEntity } from './entities/datos_generales_empresa_entity';
import { UbicacionEntity } from './entities/ubicacion_entity';
import { EstadoCivilEntity } from './entities/estado_civil_entity'
import { ClienteLogin } from '../../login/cliente_login';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { correctHeight, detectBody, smoothlyMenu } from "../../../app.helpers";
import { CustomValidators } from 'ng2-validation';
import { UtilService } from "../../../components/common/utils/util.service";
import { SessionStorageService } from "ngx-webstorage";

const swal = require("sweetalert2");


declare var jQuery: any;

@Component({
    selector: 'infoClienteEmpresa',
    providers: [DatosGeneralesService],
    templateUrl: 'datos-generales-empresa.template.html',
    styleUrls: ["datos-generales.style.css"]
})
export class datosGeneralesEmpresa implements OnInit {
    usuario: ClienteLogin;
    clienteMasivosEmpresa: ClienteEmpresaEntity;
    listaEstadosClivl: EstadoCivilEntity[];
    provincias: UbicacionEntity[];
    ciudades: UbicacionEntity[];
    sectores: UbicacionEntity[];
    ciudadesTrabajo: UbicacionEntity[];
    sectoresTrabajo: UbicacionEntity[];
    errorMessage: string;
    showLoader: string;
    es: any;
    inicioAnio: number;
    finAnio: number;


    constructor(
        public utilsService: UtilService,
        private datosGeneralesSevice: DatosGeneralesService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        private sesionStorageService: SessionStorageService
    ) {

    }

    actualizarClienteEmpresa(): void {
        this.datosGeneralesSevice.actualizarClienteEmpresa(this.clienteMasivosEmpresa).subscribe(
            datosClienteEmpresa => {
                if (datosClienteEmpresa) {
                    swal({
                        title: 'Datos actualizados',
                        text: "Su información ha sido actualizada satisfactoriamente",
                        type: 'success'
                    });
                }
            },
            error => { this.handleError.redirectUrl(error); });
    }

    cargarCiudades(provCod, estaSeleccionado): void {
        if (provCod != "0") {
            this.datosGeneralesSevice.consultaCiudades(provCod).subscribe(ciudades => {
                this.ciudades = ciudades;
                if (this.ciudades.length == 0) {
                    this.clienteMasivosEmpresa.CodCiudadOficina = 0;
                    this.clienteMasivosEmpresa.CodSectorOficina = 0;
                } 
                if(estaSeleccionado == false)               
                    this.clienteMasivosEmpresa.CodCiudadOficina = 0;

            }, error => this.handleError.redirectUrl(error))
        } else {
            this.ciudades = null;
            this.sectores = null;
            this.clienteMasivosEmpresa.CodCiudadOficina = 0;
            this.clienteMasivosEmpresa.CodSectorOficina = 0;
        }
    }

    cargarSectores(ciuCod): void {
        if (ciuCod != "0") {
            this.datosGeneralesSevice.consultaSectores(ciuCod).subscribe(sectores => {
                this.sectores = sectores;
                if (this.sectores.length == 0)
                    this.clienteMasivosEmpresa.CodSectorOficina = 0;
            }, error => this.handleError.redirectUrl(error))
        } else {
            this.sectores = null;
            this.clienteMasivosEmpresa.CodSectorOficina = 0;
        }
    }

    ngOnInit(): void {
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error);
            return;
        }
        /*correctHeight();
        detectBody();*/
        this.es = {
            firstDayOfWeek: 1,
            dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
            dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
            dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
            monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
            monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
        }
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        }
        let bandera = this.sessionTokenService.useJwtHelper();
        if (!bandera) {
            this.clienteMasivosEmpresa = new ClienteEmpresaEntity();
            this.datosGeneralesSevice.consultaEstadoCivil().subscribe(listaEstadosClivl => this.listaEstadosClivl = listaEstadosClivl, error => this.handleError.redirectUrl(error))
            this.datosGeneralesSevice.consultaProvincias().subscribe(provincias => this.provincias = provincias, error => this.handleError.redirectUrl(error))
            this.datosGeneralesSevice.datosClienteEmpresa().subscribe(
                datosClienteEmpresa => {
                    this.clienteMasivosEmpresa = datosClienteEmpresa;
                    this.sesionStorageService.store("NombreUser", JSON.stringify(this.clienteMasivosEmpresa.RazonSocial));
                    if (this.clienteMasivosEmpresa.CodSectorOficina == null) {
                        this.clienteMasivosEmpresa.CodSectorOficina = 0;
                    }
                    if (this.clienteMasivosEmpresa.CodCiudadOficina == null) {
                        this.clienteMasivosEmpresa.CodCiudadOficina = 0;
                    }
                    if (this.clienteMasivosEmpresa.CodProvinciaOficina == null) {
                        this.clienteMasivosEmpresa.CodProvinciaOficina = 0;
                    }
                    this.cargarCiudades(this.clienteMasivosEmpresa.CodProvinciaOficina, true);
                    this.cargarSectores(this.clienteMasivosEmpresa.CodCiudadOficina);
                },
                error => { this.handleError.redirectUrl(error); });
        }
    }

}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/datos-generales-empresa.component.ts